// BASE, CLEAN STATE

const cleanState = {
  readIndex: 0,
  storedData: {
    totalSharesGraph: [],
    totalShares: [],
    totalSalesGraph: [],
    totalSales: [],
    salesDrivers: {
      plotData: [],
      salesTrendTables: [],
      dateRange: [],
    },
    marketShare: {
      marketSalesTable: {
        top5SalesTrendTables: [],
        top5SalesPlotData: [],
        closest5SalesPlotData: [],
        closest5SalesTrendTables: []
      },
      marketSharesTable: {
        top5SharesTrendTables: [],
        top5SharesPlotData: [],
        closest5SharesPlotData: [],
        closest5SharesTrendTables: [],
      },
    },
    topPerformers: []
  }
};

const initialState = {
  ...cleanState,
};

export default (state = initialState, { type, value }) => {
  switch (type) {
    case 'SET_READ_INDEX':
      return {
        ...state,
        readIndex: value,
      };
    case 'SET_STORED_DATA':
      return {
        ...state,
        storedData: value,
      };
    default:
      return state;
  }
};
